var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropSunicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.433,
    height: 22.434,
    viewBox: "0 0 22.433 22.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9263",
    "data-name": "Group 9263",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M3609.468,324.862a7.285,7.285,0,1,1-7.285-7.285A7.285,7.285,0,0,1,3609.468,324.862Z",
    transform: "translate(-3589.138 -311.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M3602.89,312.374l.97-2.5a.559.559,0,0,1,1.051.026l.834,2.5a.559.559,0,0,1-.531.735h-1.8A.558.558,0,0,1,3602.89,312.374Z",
    transform: "translate(-3591.269 -309.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M3589.941,328.358l-2.5-.972a.559.559,0,0,1,.026-1.051l2.5-.832a.559.559,0,0,1,.736.53v1.8A.559.559,0,0,1,3589.941,328.358Z",
    transform: "translate(-3587.086 -313.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M3593.284,317.6l-1.08-2.454a.559.559,0,0,1,.761-.724l2.356,1.177a.559.559,0,0,1,.145.895l-1.276,1.276A.559.559,0,0,1,3593.284,317.6Z",
    transform: "translate(-3588.431 -310.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M3595.4,337.668l-2.454,1.079a.559.559,0,0,1-.725-.761l1.178-2.357a.559.559,0,0,1,.9-.145l1.276,1.277A.559.559,0,0,1,3595.4,337.668Z",
    transform: "translate(-3588.431 -316.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M3615.237,317.826l1.079-2.454a.559.559,0,0,0-.762-.724l-2.354,1.179a.558.558,0,0,0-.145.894l1.276,1.275A.559.559,0,0,0,3615.237,317.826Z",
    transform: "translate(-3593.932 -310.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9988",
    "data-name": "Path 9988",
    d: "M3609.468,324.862a7.285,7.285,0,1,1-7.285-7.285A7.285,7.285,0,0,1,3609.468,324.862Z",
    transform: "translate(-3591.282 -313.854)",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9903",
    "data-name": "Path 9903",
    d: "M3609.468,324.862a7.285,7.285,0,1,1-7.285-7.285A7.285,7.285,0,0,1,3609.468,324.862Z",
    transform: "translate(-3589.158 -311.656)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropSunicon);
export default __webpack_public_path__ + "static/media/cropSunicon.d71d7eb5c4be7925b2ced6caef7a7be8.svg";
export { ForwardRef as ReactComponent };